'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.helpers = undefined;
exports.provide = provide;
exports.connect = connect;

var _helpers = require('./helpers');

var helpers = _interopRequireWildcard(_helpers);

var _isClass = require('is-class');

var _isClass2 = _interopRequireDefault(_isClass);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

var currentStore = void 0;

var defaultMapState = function defaultMapState() {
  return {};
};

var defaultMapDispatch = function defaultMapDispatch(dispatch) {
  return {
    dispatch: dispatch
  };
};

exports.helpers = helpers;

function provide(store) {
  currentStore = store;
}

function connect() {
  var mapState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultMapState;
  var mapDispatch = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultMapDispatch;

  if (typeof mapState !== 'function') {
    mapState = defaultMapState; // eslint-disable-line no-param-reassign
  }

  return function (component) {
    return function () {
      if (!currentStore) {
        throw new Error('You cannot use connect unless you `provide` a store');
      }

      var actions = (0, _helpers.wrapActionCreators)(mapDispatch)(currentStore.dispatch);
      var currentState = mapState(currentStore.getState());
      var calledComponent = void 0;

      if ((0, _isClass2.default)(component)) {
        var Component = component;
        calledComponent = new Component();
        calledComponent.state = currentState;
        calledComponent.actions = actions;
        if (typeof calledComponent.init === 'function') calledComponent.init();
        (0, _helpers.observeStore)(currentStore, currentState, mapState, function (newState, oldState) {
          calledComponent.state = newState;
          if (typeof calledComponent.updated === 'function') calledComponent.updated(oldState);
        });
      } else {
        calledComponent = component(currentState, actions);

        if (calledComponent) {
          (0, _helpers.observeStore)(currentStore, currentState, mapState, calledComponent.updated);
        }
      }

      return calledComponent;
    };
  };
}